import { CheckSquareOutlined as AntCheckSquareOutlined } from '@ant-design/icons';
import { Colors } from '@eservices/ui-constants/colors';
import styled from 'styled-components';

export default styled(AntCheckSquareOutlined)`
    color: ${Colors.PRIMARY},
    fontSize: '20px' ,
`;
